import withNextStep from 'core/libs/hoc/withNextStep';
import withScores from 'core/libs/hoc/withScores';
import withUserScore from 'core/libs/hoc/withUserScore';
import {navigate} from 'gatsby';
import Link from 'modules/common/Link';
import NewDesignButton from 'modules/common/NewDesignButton';
import EarnPoint from 'modules/common/Svg/EarnPoint';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import {
  compose,
  lifecycle,
  setPropTypes,
  withProps,
  withState,
} from 'recompose';
import {label, pointsLeft} from './styles.scss';

const VideoOverlay = ({
  completeProgress,
  nextStep,
  isScoreVisible,
  timeLeft,
  closeVideoOverlay,
  currentUserScore,
  lastTopTenScore,
  pointsToReachTopTen,
}) => (
  <div className="aspect-ratio--object bg-black-90 flex justify-center items-center">
    <div className="tc">
      <div>
        <h2 className="white mb2 f3-ns f5">
          <FormattedMessage id="well_done" />
        </h2>
        <p className="white mb3 f3-ns f5 b">
          <FormattedMessage id="video_ended" />
        </p>
        <EarnPoint />
        {isScoreVisible && (
          <p className="mt2 green f3-ns f5 b">
            +2 <FormattedMessage id="points_max" />
          </p>
        )}
        {pointsToReachTopTen !== null && pointsToReachTopTen > 0 && (
          <p className={`pa2 b white mh3 mv2 mv3-ns ${label}`}>
            <FormattedMessage
              id="step_result_label"
              values={{
                points: (
                  <div className={pointsLeft}>
                    {lastTopTenScore -
                      currentUserScore -
                      (isScoreVisible ? 2 : 0)}
                  </div>
                ),
              }}
            />
          </p>
        )}
        <Link
          className="mt2 db white f5-ns f6 b"
          onClick={completeProgress}
          to={nextStep.url}
        >
          <FormattedMessage id="next" />
          {' : '}
          <span className="green bb b--green">{nextStep.text}</span>
        </Link>
        <p className="white mt3">
          <FormattedMessage id="after" />
          {` ${timeLeft} `}
          <FormattedMessage id="seconds" />
        </p>
        <NewDesignButton
          className="mt5-l mt4-m mt2 fw6 white pv2 dim ba b--white pa3-ns ph2"
          onClick={closeVideoOverlay}
        >
          <FormattedMessage id="stay_here" />
        </NewDesignButton>
      </div>
    </div>
  </div>
);

VideoOverlay.propTypes = {
  isScoreVisible: PropTypes.bool.isRequired,
  timeLeft: PropTypes.number.isRequired,
  closeVideoOverlay: PropTypes.func.isRequired,
  nextStep: PropTypes.object.isRequired,
  currentUserScore: PropTypes.number,
  lastTopTenScore: PropTypes.number,
  pointsToReachTopTen: PropTypes.number,
  completeProgress: PropTypes.func,
};

const mapStateToProps = ({user, leaderboard: {userScore, scores}}) => {
  return {
    user: user.profile.data,
    currentUserScore:
      (userScore && userScore.data && userScore.data.score) || 0,
    topUsersLength: scores && scores.data && scores.data.length,
    lastTopTenScore:
      scores &&
      scores.data &&
      scores.data.length > 0 &&
      scores.data[scores.data.length - 1] &&
      scores.data[scores.data.length - 1].total_score,
  };
};

const enhance = compose(
  setPropTypes({
    id: PropTypes.number.isRequired,
  }),
  connect(mapStateToProps),
  withNextStep,
  withState('timeLeft', 'setTimeLeft', 5),
  withScores({force: true, callOnUpdate: false}),
  withUserScore({force: true, callOnUpdate: false}),
  lifecycle({
    componentDidMount() {
      const {completeProgress, nextStep, setTimeLeft} = this.props;

      if (window && nextStep.url) {
        this.contDownInterval = setInterval(() => {
          setTimeLeft((timeLeft) => {
            if (timeLeft === 0) {
              window.clearInterval(this.contDownInterval);
              if (completeProgress) {
                completeProgress();
              }
              navigate(nextStep.url);
              return timeLeft;
            }
            return timeLeft - 1;
          });
        }, 1000);
      }
    },
    componentDidUpdate({nextStep: prev_nextStep}) {
      const {closeVideoOverlay, nextStep} = this.props;
      if (this.contDownInterval && nextStep.url !== prev_nextStep.url) {
        closeVideoOverlay();
      }
    },
    componentWillUnmount() {
      if (window && this.contDownInterval) {
        clearInterval(this.contDownInterval);
      }
    },
  }),
  withProps(({lastTopTenScore, currentUserScore}) => {
    return {
      pointsToReachTopTen:
        lastTopTenScore && lastTopTenScore - currentUserScore,
    };
  }),
);

export default enhance(VideoOverlay);
